import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ComplianceIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.17 2.478a.48.48 0 0 0-.34 0l-.269-.7.268.7L3.36 4.19a.48.48 0 0 0-.306.445V7.67c0 1.15.367 2.249 1.018 3.151a5.2 5.2 0 0 1 7.936-.113c.603-.88.94-1.935.94-3.038V4.635a.48.48 0 0 0-.306-.445zl.268-.7zm2.817 9.347a3.7 3.7 0 0 0-2.774-1.397 3.72 3.72 0 0 0-3.092 1.483q.3.236.637.429l-.373.65.373-.65 2.005 1.15a.48.48 0 0 0 .474 0l2.005-1.15a5.4 5.4 0 0 0 .745-.515M7.293 1.078a1.98 1.98 0 0 1 1.414 0l4.47 1.711a1.98 1.98 0 0 1 1.27 1.846V7.67a6.88 6.88 0 0 1-3.459 5.971l-2.005 1.15-.373-.65.373.65c-.609.35-1.358.35-1.967 0l.374-.65-.374.65-2.005-1.15A6.88 6.88 0 0 1 1.553 7.67V4.635c0-.818.505-1.553 1.27-1.846zM8 4.95a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      clipRule="evenodd"
    />
  </svg>
);
ComplianceIcon.id = 'ComplianceIcon';
ComplianceIcon.displayName = 'ComplianceIcon';
export default ComplianceIcon;
